import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RootService } from './service/root.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public rootService: RootService, private translate: TranslateService) { }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts